import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Import theme
import theme from './theme';

// Import components
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Dashboard2 from './pages/Dashboard2';
import Test from './pages/Test';
import TestCompleted from './pages/TestCompleted';
import Page2 from './pages/Page2';
import Footer from './components/Footer';

// Component to conditionally render Navbar and Footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isTestPage = location.pathname === '/test';
  
  return (
    <>
      {!isTestPage && <Navbar />}
      {children}
      {!isTestPage && <Footer />}
    </>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Page2 />} />
            {/* <Route path="/login" element={<Login />} /> */}
            <Route path="/dashboard" element={<Dashboard2 />} />
            {/* <Route path="/dash" element={<Dashboard2 />} /> */}
            <Route path="/test" element={<Test />} />
            <Route path="/test-completed" element={<TestCompleted />} />
          </Routes>
        </Layout>   
      </Router>
    </ThemeProvider>
  );
}

export default App;
